import React from "react";
import { MotionModal, ModalCloseButton } from "../../../../../../components/motion";

const SaveDraftConfirmationModal = ({ show, onClose, onConfirm, isSaving }) => {
    return (
        <MotionModal
            show={show}
            onClose={onClose}
            maxWidthClassName="tw:max-w-[500px]"
            panelClassName="tw:px-4 tw:py-5 tw:md:px-10 tw:md:py-8"
        >
                <ModalCloseButton onClick={onClose} />

                <div className="tw:!text-center tw:!mt-4 tw:!mb-6">
                    <p className="tw:!text-[#282828] tw:!mb-0 tw:!text-[18px] tw:!font-[600] tw:font-hanken-grotesk tw:max-w-full">
                        Would you like to save as draft the booking details?
                    </p>
                </div>

                <div className="tw:flex tw:flex-col tw:lg:flex-row tw:items-stretch tw:gap-2">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isSaving}
                        className="tw:flex-1"
                    >
                        <div className="tw:!py-3 tw:w-full tw:rounded-[8px] tw:border tw:border-[#d0d0d0] tw:bg-white tw:text-[#282828] tw:text-[15px] tw:leading-[22px] tw:font-medium tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center">
                            Back
                        </div>
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isSaving}
                        className="tw:flex-1"
                    >
                        <div className={`tw:!py-3 tw:w-full tw:rounded-[8px] tw:bg-[#7C7B7B] tw:text-white tw:text-[15px] tw:leading-[22px] tw:!font-[700] tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center tw:gap-2 ${isSaving ? "tw:opacity-70" : ""}`}>
                            {isSaving && (
                                <svg className="tw:animate-spin tw:h-4 tw:w-4 tw:text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="tw:opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                    <path className="tw:opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                                </svg>
                            )}
                            {isSaving ? "Saving…" : "Save as Draft"}
                        </div>
                    </button>
                </div>
        </MotionModal>
    );
};

export default SaveDraftConfirmationModal;
